export default __webpack_public_path__ + "static/media/info-circle.821ece58.svg";